const AVATAR_BASE_PATH = '/img';

const DEFAULT_AVATAR_SVG =
  "<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'><rect width='200' height='200' rx='100' fill='%232b2f3a'/><circle cx='100' cy='78' r='38' fill='%234b5563'/><path d='M85 120c0-10 8-18 18-18h14c10 0 18 8 18 18v10c0 18-15 32-33 32s-33-14-33-32v-10z' fill='%23374151'/><path d='M118 58v45a14 14 0 1 1-8-13V46h18v12z' fill='%23a855f7'/></svg>";

export const DEFAULT_AVATAR_URL = `data:image/svg+xml;utf8,${encodeURIComponent(
  DEFAULT_AVATAR_SVG
)}`;

const INSTRUMENT_AVATAR_MAP: Record<string, string> = {
  guitar: 'guitar.svg',
  bass: 'bass.svg',
  drums: 'drums.svg',
  vocals: 'vocal.svg',
  piano: 'piano.svg',
  saxophone: 'saxophone.svg',
  trumpet: 'trumpet.svg',
  violin: 'violin.svg',
  cello: 'cello.svg',
  flute: 'flute.svg',
  clarinet: 'clarinet.svg',
  trombone: 'trombone.svg',
};

export const INSTRUMENT_OPTIONS = [
  'Guitar',
  'Bass',
  'Drums',
  'Vocals',
  'Piano',
  'Saxophone',
  'Trumpet',
  'Violin',
  'Cello',
  'Flute',
  'Clarinet',
  'Trombone',
];

const normalizeInstrument = (instrument?: string): string | null => {
  if (!instrument) return null;
  const trimmed = instrument.trim();
  if (!trimmed) return null;
  return trimmed.toLowerCase();
};

export const getInstrumentAvatarUrl = (instrument?: string): string => {
  const normalized = normalizeInstrument(instrument);
  const filename = normalized ? INSTRUMENT_AVATAR_MAP[normalized] : null;
  return filename ? `${AVATAR_BASE_PATH}/${filename}` : DEFAULT_AVATAR_URL;
};
